import {GetterTree} from 'vuex'
// @ts-ignore
import {IServiceBookState} from './service-book-state.store'
import {IRootState} from '../root-state.store'


export const getters: GetterTree<IServiceBookState, IRootState> = {
  service: (state: IServiceBookState) => {
    return state.service
  },
  serviceBooks:(state: IServiceBookState) => {
    return state.serviceBooks
  },
  count:(state: IServiceBookState) => {
    return {free:state.free, used:state.used}
  },
  isLoading:(state: IServiceBookState) => {
    return state.isLoading
  },
  currentServiceBook:(state: IServiceBookState) => {
    return state.currentServiceBook
  },
  searchParams:(state: IServiceBookState) => {
    return state.serviceBookSearchParams
  },
  patchData:(state: IServiceBookState) => {
    return state.patchServiceBook
  },
}



// WEBPACK FOOTER //
// ./src/store/service-book/service-book-getters.store.ts